const SvgAIandMl3 = (props) => (
  <>
    <circle r={1} fill="#001d6c" />
    <circle cx={16} r={1} fill="#001d6c" />
    <circle cx={32} r={1} fill="#001d6c" />
    <circle cx={48} r={1} fill="#001d6c" />
    <circle cx={64} r={1} fill="#001d6c" />
    <circle cx={80} r={1} fill="#001d6c" />
    <circle cx={96} r={1} fill="#001d6c" />
    <circle cx={112} r={1} fill="#001d6c" />
    <circle cx={128} r={1} fill="#001d6c" />
    <circle cx={144} r={1} fill="#001d6c" />
    <circle cx={160} r={1} fill="#001d6c" />
    <circle cx={176} r={1} fill="#001d6c" />
    <circle cx={192} r={1} fill="#001d6c" />
    <circle cy={16} r={1} fill="#001d6c" />
    <circle cx={16} cy={16} r={1} fill="#001d6c" />
    <circle cx={32} cy={16} r={1} fill="#001d6c" />
    <circle cx={48} cy={16} r={1} fill="#001d6c" />
    <circle cx={64} cy={16} r={1} fill="#001d6c" />
    <circle cx={80} cy={16} r={1} fill="#001d6c" />
    <circle cx={96} cy={16} r={1} fill="#001d6c" />
    <circle cx={112} cy={16} r={1} fill="#001d6c" />
    <circle cx={128} cy={16} r={1} fill="#001d6c" />
    <circle cx={144} cy={16} r={1} fill="#001d6c" />
    <circle cx={160} cy={16} r={1} fill="#001d6c" />
    <circle cx={176} cy={16} r={1} fill="#001d6c" />
    <circle cx={192} cy={16} r={1} fill="#001d6c" />
    <circle cy={32} r={1} fill="#001d6c" />
    <circle cx={16} cy={32} r={1} fill="#001d6c" />
    <circle cx={32} cy={32} r={1} fill="#001d6c" />
    <circle cx={48} cy={32} r={1} fill="#001d6c" />
    <circle cx={64} cy={32} r={1} fill="#001d6c" />
    <circle cx={80} cy={32} r={1} fill="#001d6c" />
    <circle cx={96} cy={32} r={1} fill="#001d6c" />
    <circle cx={112} cy={32} r={1} fill="#001d6c" />
    <circle cx={128} cy={32} r={1} fill="#001d6c" />
    <circle cx={144} cy={32} r={1} fill="#001d6c" />
    <circle cx={160} cy={32} r={1} fill="#001d6c" />
    <circle cx={176} cy={32} r={1} fill="#001d6c" />
    <circle cx={192} cy={32} r={1} fill="#001d6c" />
    <circle cy={48} r={1} fill="#001d6c" />
    <circle cx={16} cy={48} r={1} fill="#001d6c" />
    <circle cx={32} cy={48} r={1} fill="#001d6c" />
    <circle cx={48} cy={48} r={1} fill="#001d6c" />
    <circle cx={64} cy={48} r={1} fill="#001d6c" />
    <circle cx={80} cy={48} r={1} fill="#001d6c" />
    <circle cx={96} cy={48} r={1} fill="#001d6c" />
    <circle cx={112} cy={48} r={1} fill="#001d6c" />
    <circle cx={128} cy={48} r={1} fill="#001d6c" />
    <circle cx={144} cy={48} r={1} fill="#001d6c" />
    <circle cx={160} cy={48} r={1} fill="#001d6c" />
    <circle cx={176} cy={48} r={1} fill="#001d6c" />
    <circle cx={192} cy={48} r={1} fill="#001d6c" />
    <circle cy={64} r={1} fill="#001d6c" />
    <circle cx={16} cy={64} r={1} fill="#001d6c" />
    <circle cx={32} cy={64} r={1} fill="#001d6c" />
    <circle cx={48} cy={64} r={1} fill="#001d6c" />
    <circle cx={64} cy={64} r={1} fill="#001d6c" />
    <circle cx={80} cy={64} r={1} fill="#001d6c" />
    <circle cx={96} cy={64} r={1} fill="#001d6c" />
    <circle cx={112} cy={64} r={1} fill="#001d6c" />
    <circle cx={128} cy={64} r={1} fill="#001d6c" />
    <circle cx={144} cy={64} r={1} fill="#001d6c" />
    <circle cx={160} cy={64} r={1} fill="#001d6c" />
    <circle cx={176} cy={64} r={1} fill="#001d6c" />
    <circle cx={192} cy={64} r={1} fill="#001d6c" />
    <circle cy={80} r={1} fill="#001d6c" />
    <circle cx={16} cy={80} r={1} fill="#001d6c" />
    <circle cx={32} cy={80} r={1} fill="#001d6c" />
    <circle cx={48} cy={80} r={1} fill="#001d6c" />
    <circle cx={64} cy={80} r={1} fill="#001d6c" />
    <circle cx={80} cy={80} r={1} fill="#001d6c" />
    <circle cx={96} cy={80} r={1} fill="#001d6c" />
    <circle cx={112} cy={80} r={1} fill="#001d6c" />
    <circle cx={128} cy={80} r={1} fill="#001d6c" />
    <circle cx={144} cy={80} r={1} fill="#001d6c" />
    <circle cx={160} cy={80} r={1} fill="#001d6c" />
    <circle cx={176} cy={80} r={1} fill="#001d6c" />
    <circle cx={192} cy={80} r={1} fill="#001d6c" />
    <circle cy={96} r={1} fill="#001d6c" />
    <circle cx={16} cy={96} r={1} fill="#001d6c" />
    <circle cx={32} cy={96} r={1} fill="#001d6c" />
    <circle cx={48} cy={96} r={1} fill="#001d6c" />
    <circle cx={64} cy={96} r={1} fill="#001d6c" />
    <circle cx={80} cy={96} r={1} fill="#001d6c" />
    <circle cx={96} cy={96} r={1} fill="#001d6c" />
    <circle cx={112} cy={96} r={1} fill="#001d6c" />
    <circle cx={128} cy={96} r={1} fill="#001d6c" />
    <circle cx={144} cy={96} r={1} fill="#001d6c" />
    <circle cx={160} cy={96} r={1} fill="#001d6c" />
    <circle cx={176} cy={96} r={1} fill="#001d6c" />
    <circle cx={192} cy={96} r={1} fill="#001d6c" />
    <circle cy={112} r={1} fill="#001d6c" />
    <circle cx={16} cy={112} r={1} fill="#001d6c" />
    <circle cx={32} cy={112} r={1} fill="#001d6c" />
    <circle cx={48} cy={112} r={1} fill="#001d6c" />
    <circle cx={64} cy={112} r={1} fill="#001d6c" />
    <circle cx={80} cy={112} r={1} fill="#001d6c" />
    <circle cx={96} cy={112} r={1} fill="#001d6c" />
    <circle cx={112} cy={112} r={1} fill="#001d6c" />
    <circle cx={128} cy={112} r={1} fill="#001d6c" />
    <circle cx={144} cy={112} r={1} fill="#001d6c" />
    <circle cx={160} cy={112} r={1} fill="#001d6c" />
    <circle cx={176} cy={112} r={1} fill="#001d6c" />
    <circle cx={192} cy={112} r={1} fill="#001d6c" />
    <circle cy={128} r={1} fill="#001d6c" />
    <circle cx={16} cy={128} r={1} fill="#001d6c" />
    <circle cx={32} cy={128} r={1} fill="#001d6c" />
    <circle cx={48} cy={128} r={1} fill="#001d6c" />
    <circle cx={64} cy={128} r={1} fill="#001d6c" />
    <circle cx={80} cy={128} r={1} fill="#001d6c" />
    <circle cx={96} cy={128} r={1} fill="#001d6c" />
    <circle cx={112} cy={128} r={1} fill="#001d6c" />
    <circle cx={128} cy={128} r={1} fill="#001d6c" />
    <circle cx={144} cy={128} r={1} fill="#001d6c" />
    <circle cx={160} cy={128} r={1} fill="#001d6c" />
    <circle cx={176} cy={128} r={1} fill="#001d6c" />
    <circle cx={192} cy={128} r={1} fill="#001d6c" />
    <circle cy={144} r={1} fill="#001d6c" />
    <circle cx={16} cy={144} r={1} fill="#001d6c" />
    <circle cx={32} cy={144} r={1} fill="#001d6c" />
    <circle cx={48} cy={144} r={1} fill="#001d6c" />
    <circle cx={64} cy={144} r={1} fill="#001d6c" />
    <circle cx={80} cy={144} r={1} fill="#001d6c" />
    <circle cx={96} cy={144} r={1} fill="#001d6c" />
    <circle cx={112} cy={144} r={1} fill="#001d6c" />
    <circle cx={128} cy={144} r={1} fill="#001d6c" />
    <circle cx={144} cy={144} r={1} fill="#001d6c" />
    <circle cx={160} cy={144} r={1} fill="#001d6c" />
    <circle cx={176} cy={144} r={1} fill="#001d6c" />
    <circle cx={192} cy={144} r={1} fill="#001d6c" />
    <circle cy={160} r={1} fill="#001d6c" />
    <circle cx={16} cy={160} r={1} fill="#001d6c" />
    <circle cx={32} cy={160} r={1} fill="#001d6c" />
    <circle cx={48} cy={160} r={1} fill="#001d6c" />
    <circle cx={64} cy={160} r={1} fill="#001d6c" />
    <circle cx={80} cy={160} r={1} fill="#001d6c" />
    <circle cx={96} cy={160} r={1} fill="#001d6c" />
    <circle cx={112} cy={160} r={1} fill="#001d6c" />
    <circle cx={128} cy={160} r={1} fill="#001d6c" />
    <circle cx={144} cy={160} r={1} fill="#001d6c" />
    <circle cx={160} cy={160} r={1} fill="#001d6c" />
    <circle cx={176} cy={160} r={1} fill="#001d6c" />
    <circle cx={192} cy={160} r={1} fill="#001d6c" />
    <circle cy={176} r={1} fill="#001d6c" />
    <circle cx={16} cy={176} r={1} fill="#001d6c" />
    <circle cx={32} cy={176} r={1} fill="#001d6c" />
    <circle cx={48} cy={176} r={1} fill="#001d6c" />
    <circle cx={64} cy={176} r={1} fill="#001d6c" />
    <circle cx={80} cy={176} r={1} fill="#001d6c" />
    <circle cx={96} cy={176} r={1} fill="#001d6c" />
    <circle cx={112} cy={176} r={1} fill="#001d6c" />
    <circle cx={128} cy={176} r={1} fill="#001d6c" />
    <circle cx={144} cy={176} r={1} fill="#001d6c" />
    <circle cx={160} cy={176} r={1} fill="#001d6c" />
    <circle cx={176} cy={176} r={1} fill="#001d6c" />
    <circle cx={192} cy={176} r={1} fill="#001d6c" />
    <circle cy={192} r={1} fill="#001d6c" />
    <circle cx={16} cy={192} r={1} fill="#001d6c" />
    <circle cx={32} cy={192} r={1} fill="#001d6c" />
    <circle cx={48} cy={192} r={1} fill="#001d6c" />
    <circle cx={64} cy={192} r={1} fill="#001d6c" />
    <circle cx={80} cy={192} r={1} fill="#001d6c" />
    <circle cx={96} cy={192} r={1} fill="#001d6c" />
    <circle cx={112} cy={192} r={1} fill="#001d6c" />
    <circle cx={128} cy={192} r={1} fill="#001d6c" />
    <circle cx={144} cy={192} r={1} fill="#001d6c" />
    <circle cx={160} cy={192} r={1} fill="#001d6c" />
    <circle cx={176} cy={192} r={1} fill="#001d6c" />
    <circle cx={192} cy={192} r={1} fill="#001d6c" />
  </>
);

export default SvgAIandMl3;
